import { Container, Row, Col } from "react-bootstrap";

const RegistrationContainer = ({ children }) => {
  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col xs={10} md={8}>
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default RegistrationContainer;
